(() => {
  const pathName = window.location.pathname;
  if (!pathName.startsWith('/collections/')) return;

  const legacyPositionKey = 'pagePosition_' + pathName;
  const legacyPaginationKey = 'pagePagination_' + pathName;
  const hasLiquidError = content => /Liquid error\s*\(/i.test(content || '');

  const removeLiquidErrorText = container => {
    if (!container) return;
    [...container.childNodes].forEach(node => {
      if (node.nodeType === Node.TEXT_NODE && hasLiquidError(node.textContent)) {
        node.remove();
      }
    });
  };

  try {
    // The compiled theme bundle previously cached every sort/filter variation
    // under the same pathname. Clear that legacy cache before the theme starts.
    sessionStorage.removeItem(legacyPositionKey);
    sessionStorage.removeItem(legacyPaginationKey);
  } catch (error) {
    console.warn('Unable to clear legacy collection history:', error);
  }

  const installGridGuard = () => {
    const grid = document.querySelector('.collection-main-body-inner');
    if (!grid) return;

    removeLiquidErrorText(grid);

    // Pagination owns saving and restoring history before binding controls.
    // Replacing its markup here would discard those newly attached listeners.
    new MutationObserver(() => removeLiquidErrorText(grid)).observe(grid, {
      childList: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.setTimeout(installGridGuard, 0), {
      once: true
    });
  } else {
    window.setTimeout(installGridGuard, 0);
  }
})();
